import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  addAcademicsProgramDetails,
  fetchAcademicsProgramDetails,
} from "../../Adapters/ApiAdapter";

const AddAcademicsProgramDetails = () => {
  const [formData, setFormData] = useState({
    program_name: "",
    academic_program_category_id: "",
  });
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetchAcademicsProgramDetails();
        if (response?.status === "true") {
          // Extract unique categories based on category ID
          const uniqueCategories = Array.from(
            new Map(
              response.data.map((item) => [
                item.academic_program_category_id,
                {
                  id: item.academic_program_category_id,
                  name: item.academic_program_category_name,
                },
              ])
            ).values()
          );
          setCategories(uniqueCategories);
        } else {
          toast.error("Failed to fetch program categories.");
        }
      } catch (error) {
        toast.error("Error loading program categories.");
      }
    };

    fetchCategories();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const programData = new FormData();
    programData.append("program_name", formData.program_name);
    programData.append(
      "academic_program_category_id",
      formData.academic_program_category_id
    );

    try {
      const response = await addAcademicsProgramDetails(programData);
      if (response && response.status === "true") {
        toast.success("Program Details added successfully!");
        setFormData({ program_name: "", academic_program_category_id: "" });
      } else {
        toast.error("Failed to add Program Details.");
      }
    } catch (error) {
      toast.error("An error occurred while adding Program Details.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box m="20px">
      <ToastContainer />
      <Typography variant="h4" gutterBottom>
        Add Academics Program Details
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Program Name"
          name="program_name"
          value={formData.program_name}
          onChange={handleInputChange}
          required
        />

        <FormControl fullWidth margin="normal" required>
          <InputLabel id="category-label">Academic Program Category</InputLabel>
          <Select
            labelId="category-label"
            name="academic_program_category_id"
            value={formData.academic_program_category_id}
            onChange={handleInputChange}
            label="Academic Program Category"
          >
            {categories.map((cat) => (
              <MenuItem key={cat.id} value={cat.id}>
                {cat.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          style={{ marginTop: "20px" }}
        >
          {loading ? <CircularProgress size={24} /> : "Add Program"}
        </Button>
      </form>
    </Box>
  );
};

export default AddAcademicsProgramDetails;
